var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5005 18.5001L7.50049 14.7501L1.50049 18.5001V2.00012C1.50049 1.80121 1.57951 1.61044 1.72016 1.46979C1.86081 1.32914 2.05158 1.25012 2.25049 1.25012H12.7505C12.9494 1.25012 13.1402 1.32914 13.2808 1.46979C13.4215 1.61044 13.5005 1.80121 13.5005 2.00012V18.5001Z",
    stroke: "#454551",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkThick);
export default __webpack_public_path__ + "static/media/bookmark-thick.68a6831c5393367272417296dcffbbe4.svg";
export { ForwardRef as ReactComponent };